<script setup lang="ts">
import { useRouter } from 'vue-router'
import { authService } from '@/services/AuthService';
import { storeToRefs } from 'pinia';
import { useDefaultStore } from '@/stores/defaultStore';

const router = useRouter()
const { isInitialized } = storeToRefs(useDefaultStore())

watch(isInitialized, async (value) => {
  if (value) {
    try {
      const response = await authService.handleRedirectPromise()
      
      if (response) {      
        // Now redirect to home, where your guard will send them to their preferred start page
        router.push('/')
      } else {
        // No response but no error either - might be a page refresh
        // Check if user is already authenticated
        const accounts = authService.getAllAccounts()
        if (accounts.length > 0) {
          router.push('/')
        } else {
          // Not authenticated, might need to trigger login again
          console.error('No authentication response received')
          authService.loginRedirect()
        }
      }
    } catch (error) {
      console.error('Authentication error:', error)
      // Handle error
      router.push({ name: 'error', query: {
        status: 403,
        title: 'Authentication error',
        description: 'Something happened during authentication that we did not expect. Try refreshing the page or clear the browser cache (if possible)'
      }})
    }
  }
}, {
  once: true
})
</script>

<template>
  <n-layout>
    <div class="h-screen w-screen flex items-center justify-center">
      <n-spin description="Authenticating" />
    </div>
  </n-layout>
</template>

<style scoped>
.auth-callback {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>